var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    attrs: {
      "search-input": _vm.searchValue
    },
    on: {
      "update:searchInput": function updateSearchInput($event) {
        _vm.searchValue = $event;
      },
      "update:search-input": function updateSearchInput($event) {
        _vm.searchValue = $event;
      },
      "click": _vm.alert,
      "keyup": [_vm.onKeyup, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search($event);
      }],
      "change": _vm.onChange
    },
    scopedSlots: _vm._u([_vm.$scopedSlots['item'] ? {
      key: "item",
      fn: function fn(_ref) {
        var parent = _ref.parent,
            item = _ref.item,
            on = _ref.on,
            attrs = _ref.attrs;
        return [_vm._t("item", null, null, {
          parent: parent,
          item: item,
          on: on,
          attrs: attrs,
          itemText: _vm.itemText
        })];
      }
    } : null, _vm.$scopedSlots['selection'] ? {
      key: "selection",
      fn: function fn(_ref2) {
        var parent = _ref2.parent,
            item = _ref2.item,
            attrs = _ref2.attrs;
        return [_vm._t("selection", null, null, {
          parent: parent,
          item: item,
          attrs: attrs,
          itemText: _vm.itemText
        })];
      }
    } : null, _vm.$scopedSlots['append'] ? {
      key: "append",
      fn: function fn() {
        return [_vm._t("append")];
      },
      proxy: true
    } : null, _vm.$scopedSlots['append-outer'] ? {
      key: "append-outer",
      fn: function fn() {
        return [_vm._t("append-outer")];
      },
      proxy: true
    } : null], null, true),
    model: {
      value: _vm.item,
      callback: function callback($$v) {
        _vm.item = $$v;
      },
      expression: "item"
    }
  }, 'v-autocomplete', Object.assign({}, _vm.$attrs, {
    items: _vm.items,
    itemText: _vm.itemText,
    itemValue: '_id',
    loading: _vm.loading,
    multiple: _vm.multiple,
    readonly: _vm.readonly,
    placeholder: _vm.placeholder,
    returnObject: _vm.returnObject
  }), false), [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }